import type { QueryApi } from "../../api/query";

export function createUsePopularShops($api: QueryApi) {
  return function usePopularShops(params: { page?: number; size: number }) {
    return $api.useQuery("get", "/shops/popular", {
      params: { query: { page: params.page ?? 0, size: params.size } },
    }, {
      staleTime: 5 * 60_000,
    });
  };
}
